import React from 'react';
import { Route, Switch } from '@bingads-webui-campaign-react/router';
import { Constants } from '@bingads-webui-campaign/dimensions-grids-config';
import { triggerQualtricsEvent } from '@bingads-webui-campaign/qualtrics';

import { StyledDimensionsPage as DimensionsPage } from './dimensions-page';

const {
  TimeDay,
  TimeHour,
  TimeDate,
  TimeWeek,
  TimeMonth,
  TimeQuarter,
  TimeYear,
  LandingPage,
  Geographic,
  UserLocation,
  LabelCampaign,
  LabelAdgroup,
  LabelKeyword,
  LabelAd,
  LabelAccount,
} = Constants;

const CampaignDimensionShell = React.memo((props) => {
  try {
    triggerQualtricsEvent('CampaignDimensionShellLoaded');
  } catch (e) {
    // Not a severe error
  }

  return (
    <Switch>
      <Route
        exact
        path="/campaign/vnext/adscheduleday"
        render={() => <DimensionsPage {...props} type={TimeDay} reportType="TimeDayOfWeek" />}
      />
      <Route
        exact
        path="/campaign/vnext/adschedulehour"
        render={() => <DimensionsPage {...props} type={TimeHour} reportType="TimeHourOfDay" />}
      />
      <Route
        exact
        path="/campaign/vnext/adscheduledate"
        render={() => <DimensionsPage {...props} type={TimeDate} reportType="TimeDate" />}
      />
      <Route
        exact
        path="/campaign/vnext/adscheduleweek"
        render={() => <DimensionsPage {...props} type={TimeWeek} reportType="TimeWeek" />}
      />
      <Route
        exact
        path="/campaign/vnext/adschedulemonth"
        render={() => <DimensionsPage {...props} type={TimeMonth} reportType="TimeMonth" />}
      />
      <Route
        exact
        path="/campaign/vnext/adschedulequarter"
        render={() => <DimensionsPage {...props} type={TimeQuarter} reportType="TimeQuarter" />}
      />
      <Route
        exact
        path="/campaign/vnext/adscheduleyear"
        render={() => <DimensionsPage {...props} type={TimeYear} reportType="TimeYear" />}
      />
      <Route
        exact
        path="/campaign/vnext/landingpages"
        render={() => <DimensionsPage {...props} type={LandingPage} reportType="DestinationUrl" />}
      />
      <Route
        exact
        path="/campaign/vnext/geographicreport"
        render={() => <DimensionsPage {...props} type={Geographic} reportType="Geographic" />}
      />
      <Route
        exact
        path="/campaign/vnext/userlocationreport"
        render={() => <DimensionsPage {...props} type={UserLocation} reportType="UserLocations" />}
      />
      <Route
        path="/campaign/vnext/labelscampaign"
        exact
        render={() => <DimensionsPage {...props} type={LabelCampaign} reportType="CampaignLabelReport" />}
      />
      <Route
        path="/campaign/vnext/labelsadgroup"
        exact
        render={() => <DimensionsPage {...props} type={LabelAdgroup} reportType="AdGroupLabelReport" />}
      />
      <Route
        path="/campaign/vnext/labelskeyword"
        exact
        render={() => <DimensionsPage {...props} type={LabelKeyword} reportType="KeywordLabelReport" />}
      />
      <Route
        path="/campaign/vnext/labelsad"
        exact
        render={() => <DimensionsPage {...props} type={LabelAd} reportType="AdLabelReport" />}
      />
      <Route
        path="/campaign/vnext/labelsaccount"
        exact
        render={() => <DimensionsPage {...props} type={LabelAccount} reportType="AccountLabelMccReport" />}
      />
    </Switch>
  );
});


export { CampaignDimensionShell };
